<template>
  <div class="layout layout--content">
    <div class="layout__item layout__item--schedule">
      <div class="container container--wide pdgx">
        <div class="text-limited mrgv+">
          <h1>{{ elementData.title }}</h1>
          <div class="text-h2 text-light mrgb+">{{ elementData.lead }}</div>
        </div>
      </div>
      <div class="teaser-list-calendar relative bg-alt flex">
        <div class="facet-sidebar flex flex-column">
          <div class="facet-sticky">
            <button
              class="btn relative text-semi text-brand flex-important flex-center-space-between pdglx"
              @click.prevent="toggleFilter"
            >
              {{ t('FILTER') }}
              <icon
                icon-id="arrow-left"
                :classes="['icon--toggle', 'bg-brand', 'text-white']"
              ></icon>
            </button>
            <selected-list></selected-list>
            <facet-bar></facet-bar>
            <facet-list></facet-list>
          </div>
        </div>
        <schedule-results></schedule-results>
        <overlay></overlay>
      </div>
    </div>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/settings'
import { mapState } from 'vuex'
import Overlay from '@/components/Overlay'
import FacetBar from '@/components/Facets/Bar'
import FacetList from '@/components/Facets/List'
import SelectedList from '@/components/Selected/List'
import ScheduleResults from '@/components/Schedule/Results'
import Icon from '@/components/Ui/Icon'

export default {
  components: {
    Overlay,
    FacetBar,
    FacetList,
    SelectedList,
    ScheduleResults,
    Icon
  },

  props: {
    elementData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    ...mapState('Schedule', {
      detailItem: (state) => state.detailItem,
      detailVisible: (state) => state.detailVisible
    })
  },

  mounted() {
    this.$store.dispatch('setConfig', APP_CONFIG.SCHEDULE)
    this.$store.dispatch('Results/load', {
      splitResults: true,
      initQueryString: true
    })
  },

  methods: {
    toggleFilter() {
      const body = document.body
      const className = ' filter-sidebar-closed'

      // eslint-disable-next-line
      console.log(body.getAttribute('class').search(className))

      if (
        body.hasAttribute('class') &&
        body.getAttribute('class').search(className) !== -1
      ) {
        body.setAttribute(
          'class',
          body.getAttribute('class').replace(className, '')
        )
      } else {
        body.setAttribute(
          'class',
          (
            (body.hasAttribute('class') ? body.getAttribute('class') : '') +
            className
          ).trim()
        )
      }
    }
  }
}
</script>
